var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockError = function SvgClockError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clockError_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m59.693 56.342-3.315 3.314L42.844 46.12a6.7 6.7 0 0 1-2.807.615c-2.89 0-5.36-1.83-6.314-4.392h-9.496v-4.687h9.496a6.75 6.75 0 0 1 6.314-4.391A6.743 6.743 0 0 1 46.773 40a6.7 6.7 0 0 1-.615 2.806z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.033 37.953a2.05 2.05 0 0 0-2.049 2.048 2.05 2.05 0 0 0 2.049 2.049A2.05 2.05 0 0 0 42.08 40a2.05 2.05 0 0 0-2.048-2.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clockError_svg__b)",
    d: "M74.431 37.658a34.2 34.2 0 0 0-3.116-12.193l-17.139-2.921 5.227-5.227a29.56 29.56 0 0 0-17.027-7.051v4.614H37.69v-4.614c-14.582 1.138-26.254 12.81-27.392 27.392h4.615v4.687h-4.615c1.139 14.583 12.81 26.254 27.392 27.393v-4.615h4.687v4.614C56.96 68.6 68.63 56.927 69.768 42.346h-4.614v-4.687zM59.688 56.342l-3.314 3.314-13.535-13.534a6.7 6.7 0 0 1-2.806.615c-2.89 0-5.36-1.83-6.314-4.392h-9.497v-4.687h9.497a6.75 6.75 0 0 1 6.314-4.392 6.743 6.743 0 0 1 6.735 6.736 6.7 6.7 0 0 1-.615 2.806z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clockError_svg__c)",
    d: "M79.964 42.343h-5.496c-.555 8.337-4.068 16.099-10.032 22.062-6.518 6.52-15.186 10.11-24.405 10.11s-17.886-3.59-24.405-10.11S5.516 49.22 5.516 40s3.59-17.886 10.11-24.405S30.812 5.485 40.03 5.485s17.887 3.59 24.405 10.11l1.657 1.656-2.193 2.194 9.413 1.605-1.605-9.413-1.737 1.737-1.657-1.657C60.76 4.16 50.714 0 40.031 0s-20.73 4.16-28.284 11.716C4.192 19.27.031 29.316.031 40s4.161 20.73 11.716 28.284C19.302 75.84 29.347 80 40.031 80c10.685 0 20.73-4.16 28.285-11.716 7-7 11.085-16.138 11.648-25.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clockError_svg__d)",
    d: "m79.658 72.27-11.66-19.817C67.036 50.818 65.352 50 63.668 50l-6.27 14.815 6.27 14.815h11.66c3.849 0 6.254-4.09 4.33-7.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clockError_svg__e)",
    d: "M59.337 52.453 47.677 72.27c-1.924 3.27.481 7.36 4.33 7.36h11.66V50c-1.684 0-3.368.818-4.33 2.453"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.704,
    d: "M63.664 57.406v10.185M63.664 73.14v1.853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "clockError_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-67.13312 53.86077 -48.8957 -60.94457 83.753 14.137)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBEDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "clockError_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.971 35.808 18.678)scale(99.0194 91.8499)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AAAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clockError_svg__d",
    x1: 68.867,
    x2: 68.867,
    y1: 47.712,
    y2: 90.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clockError_svg__e",
    x1: 55.333,
    x2: 55.333,
    y1: 47.712,
    y2: 90.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clockError_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgClockError;